var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "scroll-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.preWorkAnalysis').toUpperCase()) + "\n        ")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "mask": "time",
      "label": _vm.$vuetify.t('$vuetify.preWorkAnalysis.estimatedTimeToCompleteVisit'),
      "rules": [_vm.rules.required, _vm.rules.gtzero],
      "required": ""
    },
    model: {
      value: _vm.estimatedTime,
      callback: function callback($$v) {
        _vm.estimatedTime = $$v;
      },
      expression: "estimatedTime"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$vuetify.t('$vuetify.preWorkAnalysis.estimatedCostOfMaterials'),
      "rules": [_vm.rules.required],
      "prefix": "£",
      "type": "number",
      "required": ""
    },
    model: {
      value: _vm.estimatedCost,
      callback: function callback($$v) {
        _vm.estimatedCost = $$v;
      },
      expression: "estimatedCost"
    }
  }), _c('media-dialog', {
    attrs: {
      "stage": "start"
    }
  })], 1), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n            ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirmPreWorkAnalysis();
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.beginWorkOnJob')) + "\n            ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted();
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.confirmArrivalDialog,
      callback: function callback($$v) {
        _vm.confirmArrivalDialog = $$v;
      },
      expression: "confirmArrivalDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.arrivalConfirmation').toUpperCase()) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.preWorkAnalysis.startedWorkAt')) + "\n        " + _vm._s(_vm.now()) + ".\n      ")]), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function click($event) {
        ;
        _vm.confirmArrivalDialog = false, _vm.dialog = true;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        _vm.confirmArrivalDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.ok')))])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }